"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeefyWithdrawStep = void 0;
const token_1 = require("../../../utils/token");
const step_1 = require("../../step");
const beefy_1 = require("../../../api/beefy");
const beefy_vault_contract_1 = require("../../../contract/vault/beefy/beefy-vault-contract");
const beefy_util_1 = require("./beefy-util");
class BeefyWithdrawStep extends step_1.Step {
    config = {
        name: 'Beefy Vault Withdraw',
        description: 'Withdraws from a yield-bearing Beefy Vault.',
    };
    vault;
    constructor(vault) {
        super();
        this.vault = vault;
    }
    async getStepOutput(input) {
        const { vaultName, depositERC20Address, depositERC20Decimals, vaultContractAddress, vaultERC20Address, } = this.vault;
        const { erc20Amounts } = input;
        const withdrawERC20Info = {
            tokenAddress: vaultERC20Address,
            decimals: beefy_1.BEEFY_VAULT_ERC20_DECIMALS,
        };
        const { erc20AmountForStep, unusedERC20Amounts } = this.getValidInputERC20Amount(erc20Amounts, erc20Amount => (0, token_1.compareERC20Info)(erc20Amount, withdrawERC20Info), undefined);
        const contract = new beefy_vault_contract_1.BeefyVaultContract(vaultContractAddress);
        const crossContractCall = await contract.createWithdrawAll();
        const { withdrawFeeAmount, withdrawAmountAfterFee } = (0, beefy_util_1.calculateOutputsForBeefyWithdraw)(erc20AmountForStep.expectedBalance, this.vault);
        const spentERC20AmountRecipient = {
            ...withdrawERC20Info,
            amount: erc20AmountForStep.expectedBalance,
            recipient: `${vaultName} Vault`,
        };
        const outputERC20Amount = {
            tokenAddress: depositERC20Address,
            decimals: depositERC20Decimals,
            expectedBalance: withdrawAmountAfterFee,
            minBalance: withdrawAmountAfterFee,
            approvedSpender: undefined,
        };
        const feeERC20AmountRecipients = withdrawFeeAmount > 0n
            ? [
                {
                    tokenAddress: depositERC20Address,
                    decimals: depositERC20Decimals,
                    amount: withdrawFeeAmount,
                    recipient: `${vaultName} Vault Withdraw Fee`,
                },
            ]
            : [];
        return {
            crossContractCalls: [crossContractCall],
            spentERC20Amounts: [spentERC20AmountRecipient],
            outputERC20Amounts: [outputERC20Amount, ...unusedERC20Amounts],
            outputNFTs: input.nfts,
            feeERC20AmountRecipients,
        };
    }
}
exports.BeefyWithdrawStep = BeefyWithdrawStep;
